import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import CustomModal from '../../../../common/Modals/CustomModal/CustomModal';
import ModalHeader from '../../../../common/Modals/CustomModal/ModalHeader';
import { fonts, themes } from '../../../../common/themes/themes';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import moment from 'moment';
import { baseDateFormatting } from '../../../../common/helper';
import DropAndSelect from '../../../../common/components/DropAndSelect/DropAndSelect';
import VerticalBarController from '../../../../common/components/VerticalBar/VerticalBarController';
import ModalFooter from '../../../../common/Modals/CustomModal/ModalFooter';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  rejoinexistdata: any;
  trans?: any;
}
const LeaveRejointargetDetails = ({
  isModalOpen,
  closeModal,
  rejoinexistdata,
  trans,
}: ModalProps) => {
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="auto"
    >
      <ModalHeader
        modal={{ modal_title: trans('Leave Details') }}
        closeModal={closeModal}
      />
      <Grid
        container
        spacing={1}
        style={{
          marginTop: '35px',
        }}
      >
        <Grid item xs={8} className="left-grid_history">
          <Grid container style={{ padding: '10px' }}>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {trans('Leave Details')}
              </Typography>
            </Grid>

            <CardContentTile
              tile_key={trans('Rejoin Date')}
              tile_value={moment(rejoinexistdata?.rejoin_date).format(
                baseDateFormatting,
              )}
            />
          </Grid>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={3} className="right-grid_history">
          <Grid container>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                  padding: '10px',
                }}
              >
                {trans('Tracking Details')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                marginTop: '10px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <VerticalBarController
                instanceId={rejoinexistdata?.workflow_instance_id}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
    </CustomModal>
  );
};
export default LeaveRejointargetDetails;
